<template>
  <div id="contenuAdmin">
    <MenuAdmin id="menuTop"/>
	<sidebar-menu v-if="!$isMobile()" :menu="verticalMenu" class="v-sidebar-menu-admin" :collapsed="myCollapse" @collapse="onCollapse"></sidebar-menu>
    <div id="main">
      <component :is="layout">
      </component>
    </div>
  </div>
</template>
<script>
import script from '../../script/script.js';
import MenuAdmin from './MenuAdmin.vue';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
export default {
  data() {
    return {
		post: {},
		myCollapse: true,
		verticalMenu:[
			{
				href:'/indexAdmin',
				title:'Accueil',
				icon:'fas fa-home'
			},
			{
				href:'/tiers',
				title:'Tiers',
				icon:'fas fa-user'
			},
			{
				href:'#',
				title:'Gestions des tickets',
				icon:'fas fa-wrench',
				child:[
					{
						title:'Suivi des tickets',
						href:'/suiviTicketAdmin'
					},
					{
						title:'Création de ticket',
						href:'/creationTicketAdmin'
					}
				]
			},
			{
				href:'#',
				title:'Outils',
				icon:'fas fa-screwdriver',
				child:[
					{
						title:'Catalogue',
						child:[
							{
								href:'/catalogue',
								title:'Export catalogue',
							}
						]
					},
					{
						title:'Carte de prospection',
						href:'/outils/prospection',
					},
					{
						title:'Livraison',
						child:[
							{
								href:'/outils/livraison/bonDeLivraison',
								title:'PV de livraison',
							}
						]
					},
					{
						title:'LDAP',
						child:[
							{
								title:'Gestion des utilisateurs',
								child: [
									{
										title: 'Liste des utilisateurs',
										href: '/gestion-user'
									},
									{
										title: 'Créer un utilisateur',
										href: '/create-user'
									}
								]
							},
							{
								title: 'Gestion des rôles',
								child: [
									{
										title: 'Liste des rôles',
										href: '/roles'
									},
									{
										title: 'Créer un rôle',
										href: '/create-role'
									}
								]
							}
						]
					},
					{
						title:'Note de frais',
						href:'/notes-de-frais',
					},
					{
						title:'Téléphonie',
						child:[
							{
								href:'/outils/telephonie/statsAppelsEntrant',
								title:'Stats appels entrant',
							}
						]
					},
					{
						title:'Importation VCF',
						href:'/outils/vcf/contactVcf',
					},
				]
			},
			{
				href:'/gestionTemplates',
				title:'Gestions des templates',
				icon:'far fa-envelope'
			},
			{
				href:'/gestionCommandeDomaine',
				title:'Gestions commande NDD',
				icon:'fas fa-globe'
			},
			{
				href:'/gestionCarroussel',
				title:'Gestions carroussel client',
				icon:'far fa-images'
			},
			{
				href:'/contratDeService',
				title:'Contrat de Service',
				icon:'fas fa-file-contract'
			},
			{
				href:'/fournisseur',
				title:'Fournisseur',
				icon:'fas fa-industry'
			},
			{
				href:'#',
				title:'Comptabilité',
				icon:'fas fa-calculator',
				child:[
					{
						title:'Export Je Pilote',
						child:[
							{
								href:'/comptabilite/exportVenteJePilote',
								title:'Export des ventes',
							},
							{
								href:'/comptabilite/exportPrelevementJePilote',
								title:'Export des prélèvements',
							},
						]
					},
					{
						href:'/comptabilite/facturation',
						title:'Facturation',
					}
				]
			},
			{
				href:'/aideAdmin',
				title:'Aide',
				icon:'fas fa-info-circle'
			},
		],
    }
  },
  mounted:function(){
     this.verifyRight();
  },
  methods: {
	verifyRight: script.verifyRight,
	onCollapse(collapsed){
		if(collapsed){
			document.getElementById('main').style.left ='3%';
		}else{
			document.getElementById('main').style.left ='12%';
		}
	}
  },
  components: {
    MenuAdmin
  },
  computed:{
    layout(){
      return(this.$route.meta.layout)+'-layout';
    }
  }
  
}
</script>
<style>
	#main{
		flex: 1 0 95%;
		transition: all .3s;
		position: absolute;
		top: 6%;
		left: 3%;
		right: 0;
		bottom: 0;
		max-height: 94%;
		overflow: auto;
	}

	.v-sidebar-menu-admin .collapse-btn{
		background-color:transparent;
		outline:none;
	}

	.v-sidebar-menu-admin .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu-admin .vsm-item.first-item>.vsm-link>.vsm-icon{
		background-color:transparent;
	}

	.v-sidebar-menu-admin{
		max-width: 12vw;
		background-color:#808285;
		position: absolute;
		height: 94%;
		top: 6%;
	}

	.v-sidebar-menu-admin div:nth-child(2){
		max-width: 12vw;
	}

	.v-sidebar-menu-admin .vsm-link{
		font-size:13px;
	}

	#contenuAdmin{
		display: flex;
		height: 100%;
		flex-wrap: wrap;
	}

	#menuTop{
		flex: 1 0 100%;
		height: 6%;
	}
</style>
